
namespace RioERP.Products {

    @Serenity.Decorators.registerClass()
    export class ProductTeacherShareGrid extends Serenity.EntityGrid<ProductTeacherShareRow, any> {
        protected getColumnsKey() { return ProductTeacherShareColumns.columnsKey; }
        protected getDialogType() { return ProductTeacherShareDialog; }
        protected getIdProperty() { return ProductTeacherShareRow.idProperty; }
        protected getInsertPermission() { return ProductTeacherShareRow.insertPermission; }
        protected getLocalTextPrefix() { return ProductTeacherShareRow.localTextPrefix; }
        protected getService() { return ProductTeacherShareService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}